import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    makeRequest,
    dispatchAction,
    displayMessage
} from 'actions';
import moment from 'moment'
import formatNumbers  from 'util/formatNumbers';

import {Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';
import Select   from 'react-select'

import {
    FETCH_ADMIN_PROMOCODES,
} from "actions/actionTypes";
import queryString from 'query-string'
import PaginationBox from'shared/PaginationBox';
import {prepareSelectOptionsList} from 'util/Utils';
import AdminPromoCodesListTable from 'dashboard/promoCodes/AdminPromoCodesListTable';
import AdminPromoCodesSearchBox from 'dashboard/promoCodes/AdminPromoCodesSearchBox'
import Datetime from 'react-datetime'
  import config from  '../../../config';
 import RemoveModalDialog from'shared/RemoveModalDialog';


class AdminPromoCodesPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
             showModal: false,
            errors: {},
            sortBy: '',
            perPage: config.table.numberPerPage,
            currentRecord:{},
        };
    };

    componentWillMount() {
        let queryParams = queryString.parse(this.props.location.search);
        console.log('queryParams', queryParams);
        let params = {
            'page': _.isUndefined(queryParams.page) || parseInt(queryParams.page) <= 1 ? 1 : parseInt(queryParams.page),
            perPage: _.isUndefined(queryParams.perPage) ? config.table.numberPerPage : parseInt(queryParams.perPage),
            sortBy: queryParams.sortBy,
            doNotUpdateUrlString: true,
        }
        this.setState({...this.state, ...params})
        if (!_.isUndefined(queryParams.searchText)) {
            params.searchText = queryParams.searchText
        }
        this.search(params)
    }


    editRecord(row) {
        console.log('moment row', moment(row.expiredAt) );
        this.setState({
            showModal: true,
            currentRecord: {
                 ...row,
                expiredAt:row.expiredAt ? moment(row.expiredAt) :false,

            },
        });
    }

    closeModal() {
        this.setState({
            showModal: false,
            currentRecord: {},
        });
    }

    showRemoveDialog(row) {
        this.setState({removeModalVisible: true, currentRecord: row});
    }


    deleteRecord() {
        this.setState({removeModalVisible: false});
        var methodData = {
            type: 'delete',
            "endpoint": "/promo-codes",
            messageData: {'#1#': 'Record'},
            messageCode: 'recordDeleted',
        };
        this.props.makeRequest({id: this.state.currentRecord._id}, methodData).then(res => {
            this.setState({currentRecord: {}});
            this.search()
        }).catch(err => {
            this.setState({currentRecord: {}});
            console.log('e', err);
        });

    }

    validateAndGetFormData() {

        var formData = _.pick(this.state.currentRecord,['Code','expiredAt', 'Condition','PromoCodeData', 'ErrorMessage',  'Amount', 'Percent', 'SellerPayout']),
            dataNotValid = false;

             if (this.state.currentRecord['Amount']   &&   isNaN(this.state.currentRecord['Amount'])  ) {
                return this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Amount is not valid'
                });
            }
        if (this.state.currentRecord['Percent']  &&  isNaN(this.state.currentRecord['Percent'])   ) {
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Percent is not valid'
            });
        }
        if (this.state.currentRecord['SellerPayout'] && isNaN(this.state.currentRecord['SellerPayout'])   ) {
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Seller Payout  is not valid'
            });
        }
         if((formatNumbers.unformat(this.state.currentRecord['Amount']) && formatNumbers.unformat(this.state.currentRecord['Percent']) ) || (!formatNumbers.unformat(this.state.currentRecord['Amount'])&& !formatNumbers.unformat(this.state.currentRecord['Percent']))){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please, specify either Percent or Amount value'
            });
        }

        if ( this.state.currentRecord.expiredAt   ) {
            if (!moment(this.state.currentRecord.expiredAt, 'D/M/YYYY').isValid()) {


                return this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'errorDateIsNotValid',
                });
            }
         }
         if (this.state.currentRecord.Condition && !_.isObject(this.state.currentRecord.Condition)){
            try {
                formData.Condition = JSON.parse(this.state.currentRecord.Condition)
                if (!_.isObject(  formData.Condition)){
                    throw false ;
                }
            } catch (e) {
                return this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Can not parse JSON data for conditions',
                });
            }
            formData.Condition = JSON.parse(this.state.currentRecord.Condition)
        }
        if (this.state.currentRecord.PromoCodeData && !_.isObject(this.state.currentRecord.PromoCodeData)){
            try {
                formData.PromoCodeData = JSON.parse(this.state.currentRecord.PromoCodeData)
                if (!_.isObject(  formData.PromoCodeData)){
                    throw false ;
                }
            } catch (e) {
                return this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Can not parse JSON string for Data',
                });
            }
            formData.PromoCodeData = JSON.parse(this.state.currentRecord.PromoCodeData)
        }
         console.log('formData', dataNotValid, formData);
        if (dataNotValid) {
            return false;
        }
        return formData
    }

    saveRecord() {
        var self = this;
        this.setState({pending: true});
        var formData = this.validateAndGetFormData();
        if (!formData) {
            this.setState({pending: false});
            return false;
        }
        var methodData = {
            "endpoint": "/promo-codes",
            type: "post",
        };
        if (this.state.currentRecord._id) {
           methodData['endpoint'] += '/' + encodeURIComponent(this.state.currentRecord._id),
               methodData['type'] = 'patch'

        }
        self.props.makeRequest(formData, methodData).then(recordUpdateResponse => {
            self.setState({pending: false});

            self.search()
            self.closeModal()
        }).catch(err => {
            self.setState({pending: false});
        });
    }


    onSortChange(field, sortPromocode) {
        console.log('field', field);
        this.setState({sortBy: field + ':' + (sortPromocode == 'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }

    search(params = {}) {
         if (this.refs.searchBox) {
            var {queryParams} = this.refs.searchBox.getSearchParams();
        } else {
            var queryParams = {}
        }
        _.extend(queryParams, params);


        if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
        } else {
            queryParams.sortBy = 'expiredAt' + ':' + (-1);
        }
        queryParams.sortBySecondary = '_id:-1';
        /* without secondary sort query, the promocode of documents with the same fields is not guaranteed across pages */

        var methodData = {
            "endpoint": "/promo-codes",
            'not_display_success_message': true,
            'success_event': FETCH_ADMIN_PROMOCODES
        };

        if (_.isUndefined(params.doNotUpdateUrlString)) {
            const stringified = queryString.stringify(_.omit(queryParams, ['include', 'lookup', 'all','sortBySecondary']));
            this.context.router.push('/admin/promo-codes?' + stringified);
        }


        return this.props.makeRequest(queryParams, methodData).then(res => {
            if (this.refs.pagination && _.isUndefined(queryParams.page)) {
                 this.refs.pagination.resetPagination();
            }
        }).catch(err => {
        });
    }


    render() {
        console.log('AdminPromoCodesPage this state', this.state);

        return (
            <div >
                <AdminPromoCodesSearchBox
                    ref="searchBox"
                    search={this.search.bind(this)}
                    {...this.props} ></AdminPromoCodesSearchBox>
                <div className="top20     pull-right">
                    <Button  onClick={( ) =>     this.setState({
                        showModal: true,
                        currentRecord: {
                        }})}
                        className="btn btn-primary">Add promo code</Button>
                 </div>
                <div className="clearfix"></div>
                {this.props.adminPromoCodes.fetched &&
                <div className="">
                    {this.props.adminPromoCodes.total == 0 ?
                        <div
                            className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'records')}</div> :
                        <div className="top10">

                            <AdminPromoCodesListTable
                                onSortChange={this.onSortChange.bind(this)}
                                showRemoveDialog={this.showRemoveDialog.bind(this)}
                                editRecord={this.editRecord.bind(this)}
                                search={this.search.bind(this)} {...this.props}  ></AdminPromoCodesListTable>
                            <PaginationBox
                                currentPage={_.isUndefined(queryString.parse(this.props.location.search).page) ? 0 : parseInt(queryString.parse(this.props.location.search).page) - 1}
                                perPage={this.refs.searchBox ? this.refs.searchBox.state.filterOptions.perPage : _.get(queryString.parse(this.props.location.search), ['perPage'], undefined)}
                                ref={'pagination'}
                                total={this.props.adminPromoCodes.total == 'initial' ? 0 : this.props.adminPromoCodes.total}
                                search={this.search.bind(this)}>
                            </PaginationBox>

                        </div>}
                </div>
                }

                <Modal onExited={this.closeModal.bind(this)} show={this.state.showModal}
                       onHide={(e) => this.setState({showModal: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.currentRecord._id ? 'Edit' : 'Add new'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <FormGroup>
                                <ControlLabel>Code</ControlLabel>
                                <FormControl type="text"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     Code: e.target.value
                                                 }
                                             })}
                                             value={this.state.currentRecord.Code }
                                             placeholder=" "/>
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>Percent</ControlLabel>
                                <FormControl type="text"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     Percent: e.target.value
                                                 }
                                             })}
                                             value={this.state.currentRecord.Percent }
                                             placeholder=" "/>
                            </FormGroup>


                            <FormGroup>
                                <ControlLabel>Amount</ControlLabel>
                                <FormControl type="text"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     Amount: e.target.value
                                                 }
                                             })}
                                             value={this.state.currentRecord.Amount }
                                             placeholder=" "/>
                            </FormGroup>


                            <FormGroup>
                                <ControlLabel>Seller Payout</ControlLabel>
                                <FormControl type="text"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     SellerPayout: e.target.value
                                                 }
                                             })}
                                             value={this.state.currentRecord.SellerPayout }
                                             placeholder=" "/>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Error Message</ControlLabel>
                                <FormControl type="text"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     ErrorMessage: e.target.value
                                                 }
                                             })}
                                             value={this.state.currentRecord.ErrorMessage }
                                             placeholder=" "/>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Data</ControlLabel>
                                <FormControl componentClass="textarea" rows="4"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     PromoCodeData: e.target.value
                                                 }
                                             })}
                                             value={_.isObject(this.state.currentRecord.PromoCodeData) ? JSON.stringify(this.state.currentRecord.PromoCodeData) : this.state.currentRecord.PromoCodeData }
                                             placeholder=" "/>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Conditions</ControlLabel>
                                <FormControl componentClass="textarea" rows="4"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     Condition: e.target.value
                                                 }
                                             })}
                                             value={_.isObject(this.state.currentRecord.Condition) ? JSON.stringify(this.state.currentRecord.Condition) : this.state.currentRecord.Condition }
                                             placeholder=" "/>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Expiration Date</ControlLabel>
                                <Datetime

                                    closeOnSelect={true}
                                    dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                    onChange={(option) => {
                                        var isSameDate =  moment(this.state.currentRecord['expiredAt']).isSame(option, 'day')
                                        this.setState( {'currentRecord': {
                                        ...this.state.currentRecord,
                                                expiredAt:option
                                        } });
                                    }}
                                    inputProps={{
                                     //   placeholder:

                                    }}
                                    value={   this.state.currentRecord.expiredAt    }
                                 />
                            </FormGroup>

                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="top20">
                        <Row className="left0">
                            <Col md={12} sm={12} xs={12} className="pleft0">
                                <Button className=" right0 pull-right btn btn-primary "
                                        disabled={this.state.pending}
                                        type="button"
                                        onClick={this.saveRecord.bind(this) }>
                                    Save
                                </Button>
                                <Button className="pull-right btn right20 btn-default" type="button"
                                        onClick={(e) => this.closeModal() }>
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>

                <RemoveModalDialog
                    show={this.state.removeModalVisible}
                    removeRecord={(e) => this.deleteRecord() }
                    closeModal={(e) => this.setState({currentRecord: false, removeModalVisible: false})}>
                </RemoveModalDialog>
            </div >
        );

    }
}

function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
        adminPromoCodes:state.adminPromoCodes
     };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminPromoCodesPage);
